import { AppSelectBase } from '@/presentation/components';
import React from 'react';
import { useRecoilState } from 'recoil';
import { signUpState } from '../atoms';
const AppSelect = ({ name, label, placeholder, required, options, isSearchable }) => {
    const [state, setState] = useRecoilState(signUpState);
    return (React.createElement(AppSelectBase, { state: state, options: options, setState: setState, name: name, label: label, placeholder: placeholder, required: required, isSearchable: isSearchable }));
};
export default AppSelect;
